import axios from 'axios'
import qs from 'qs'

function parseOAuthState(raw_state) {
    if (!raw_state) return {}
    if (typeof raw_state === 'object') return raw_state
    if (typeof raw_state !== 'string') return {}
    try {
        return JSON.parse(raw_state)
    } catch (e) {
        try {
            return JSON.parse(decodeURIComponent(raw_state))
        } catch (err) {
            return {}
        }
    }
}

export default async function request(url, body = {}){
    const params = new URLSearchParams(window.location.search)
    const url_language = params.get('language')
    const state_language = parseOAuthState(params.get('state')).language
    const user_language = url_language || state_language || navigator.language || navigator.userLanguage || "en"
    var language = "en"
    if (user_language.startsWith('zh')) {
        language = "zh-CN"
    }
    Object.assign(body, {language: language})

    try{
        const {data:res} = await axios.post(url + '.php', qs.stringify(body), {timeout: 15000})     
        return res
    }catch(e){
        return false
    }
    
}
